<template>
              <v-card class="black printer_card" width="220" min-width="200">
                <v-card-text @click="showHandler(printer)" class="secondary cursorpointer">

                  <v-img
                    class = "pa-2 ma-0 black rounded"
                    height = '150'
                    :key="componentKey"
                    :src="getImageUrlByObject(printer)"
                    aspect-ratio="1"

                  >
                    <v-badge
                      :color="colorState"
                      overlap
                      left
                      inline
                    >
                     <v-card-title v-text="printer.name"></v-card-title>
                    </v-badge>

                    <v-progress-linear
                      v-model="progressPrint"
                      color="primary"
                      height="15"
                      class="mt-10"
                      v-bind:class="classSupervision('text-xl-h6')"
                    >
                      <template v-slot:default="{ value }">
                        <strong >{{ Math.ceil(value) }}%</strong>
                      </template>
                    </v-progress-linear>
                    <span v-if="printer.toolHead" class="body-2 d-inline-block text-truncate font-italic" v-bind:class="classSupervision('text-xl-h6')">{{ printer.toolHead.name }}</span>
                    <span v-else class="body-2 d-inline-block text-truncate font-italic" v-bind:class="classSupervision('text-xl-h6')">{{$t('printer.toolnodefine')}}</span>

                  </v-img>
                 </v-card-text>

                 <v-card-actions class="cursorpointer" @click="linkMachine()">
                   <span class="d-inline-block text-truncate">{{ printer.machine.name }}</span>
                   <v-spacer></v-spacer>

                 </v-card-actions>
               </v-card>
</template>

<script>
import ListMixin from '../../mixins/ListMixin';
import { colorPrinter } from '../../utils/color';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'PrinterShow',
  servicePrefix: 'Printer',
  mixins: [ListMixin,FileMixin],
  components: {

  },
  props: {
    printer: {
      type: Object,
      required: true
    },
    supervision: {
      type: Boolean,
      required: false,
      default: () => false
    },
  },
  data() {
    return {
    };
  },
  computed: {
    colorState() {
      return colorPrinter(this.printer);
    },
    progressPrint() {
      if (this.printer) {
        if (this.printer.layerTotal > 0) {
          return Math.round((this.printer.layerPrint * 100) / this.printer.layerTotal);
        }
      }
      return 0;

    },

  },
  methods:{
    linkMachine: function () {
        window.open("http://"+ this.printer.address, "_blank");
    },
    classSupervision(classText) {
      if (this.supervision) return classText;
      return '';
    },
    colorPrinter

  }
};
</script>
